// @flow
import { spawn } from "redux-saga/effects";
import myAbsenceStageSaga from "./my-absence-stage";
import myAbsencesSaga from "./my-absences";
import myDetailsSaga from "./my-details";
import myEmployeesSaga from "./my-employees";
import adviceLibrary from "./advice-library";
import serviceDirectory from "./service-directory";
import serviceDesk from "./service-desk";

export default function* profileSaga(): Generator<*, void, void> {
  yield spawn(myAbsenceStageSaga);
  yield spawn(myAbsencesSaga);
  yield spawn(myDetailsSaga);
  yield spawn(myEmployeesSaga);
  yield spawn(adviceLibrary);
  yield spawn(serviceDirectory);
  yield spawn(serviceDesk);
}
